/**
 * Sets css variables based on theme config.
 * @param {Object} themeConfig
 * @param {String} theme
 */
export default function setVuetifyColorsCssVariables(themeConfig, theme) {
  const root = document.querySelector(":root");
  const selectedTheme = themeConfig.themes[theme];

  for (const [colorName, colorValue] of Object.entries(selectedTheme)) {
    root.style.setProperty(createCssVariable(colorName), colorValue);
  }
}

/**
 * Returns a vuetify-valid css variable.
 *  Vuetify constructs css variables as such:
 *  --v + (colorName from themeConfig) + -base.
 * @param {String} name
 * @returns
 */
function createCssVariable(name) {
  return `--v-${name}-base`;
}
